
export { default as TranslationDeliverablesCardLink } from './TranslationDeliverablesCardLink';
